import { HeaderInfo } from '@/UI/HeaderInfo';
import { motion } from 'framer-motion';
import { ItemTab } from './Tabs/ItemTab';
import { useClient } from '@/hooks/useClient';
import i18n from '@/localisation/i18n';
import { TestSlider } from '@/components/Tests/TestSlider';

export const Client = () => {
  const currentClient = useClient();

  if (currentClient === undefined) return null;

  const smerUnread =
    currentClient.smerIds.length - currentClient.smerViewed.size;
  const daybookUnread =
    currentClient.daybooksIds.length - currentClient.daybooksViewed.size;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <HeaderInfo
        title={currentClient.userName}
        subtitle={i18n.t('client.subtitle')}
        backUrl="/"
      >
        <div className="mt-8 flex flex-col gap-2 xl:flex-row">
          <ItemTab
            title={i18n.t('client.tab.smer.title')}
            subtitle={i18n.t('client.tab.smer.title')}
            id="smer"
            isBlocked={!currentClient.shareWithPsySmer}
            unread={smerUnread}
          />
          <ItemTab
            title={i18n.t('client.tab.daybook.title')}
            subtitle={i18n.t('client.tab.daybook.subtitle')}
            id="daybook"
            isBlocked={!currentClient.shareWithPsyDaybook}
            unread={daybookUnread}
          />
        </div>
        <div className="mt-8">
          <TestSlider />
        </div>
      </HeaderInfo>
    </motion.div>
  );
};
